<template>
  <div class="d-flex flex-wrap">
    <div class="d-flex flex-wrap">
    <div class="col-xs-6 col-md-6 p-0 pl-sm-2">
      <div class="job-card">
        <p>Welcome Message when applied for this vacancy</p>
        <quill-editor
          v-model="settings.welcomeMessage"
          ref="myQuillEditor"
          :options="editorOption"
        >
        </quill-editor>
      </div>
    </div>
    <div class="col-xs-6 col-md-6 p-0 pl-sm-2">
      <div class="job-card">
        <p>Rejected message when application rejected by HR</p>
        <quill-editor
          v-model="settings.rejectMessage"
          ref="myQuillEditor"
          :options="editorOption"
        >
        </quill-editor>
      </div>
    </div>
    </div>
    <div class="col-xs-12 col-md-12 job-card">
      <div class="d-flex align-items-center">
        <label class="col-form-label">  Interview Schedule for this vacancy</label>
      </div>
      
      <div class="job-card">
        

        <div class="d-flex">
          <div class="col-xs-2 col-md-2 p-0 pl-sm-2">
            <label class="col-form-label">  Interview Duration</label>
        <div class="form-group">
            <select v-model="settings.interviewDuration" class="form-control">
              <option v-for="item in durationList" :key="item.value" :value="item.value">{{item.text}} </option>
            </select>
        </div>
            </div>
            <div class="col-xs-2 col-md-2 p-0 pl-sm-2">
                <label class="col-form-label">  Interview Start Time</label>
            <div class="form-group">
            <select v-model="settings.interviewStartTime" class="form-control">
              <option v-for="item in amList" :key="item.value" :value="item.value">{{item.text}} </option>
            </select>
            </div>
            </div>
            <div class="col-xs-2 col-md-2 p-0 pl-sm-2">
                <label class="col-form-label">  Interview Close Time</label>
            <div class="form-group">
            <select v-model="settings.interviewEndTime" class="form-control">
              <option v-for="item in pmList" :key="item.value" :value="item.value">{{item.text}} </option>
            </select>
            </div>
            </div>
        </div>
        <div class="d-flex align-items-center">
        <input type="checkbox" v-model="settings.isInterviewAvailableWeekend"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Do you do interview on saturday? </label>
      </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-12 job-card">
      <div class="d-flex align-items-center">
        <input type="checkbox" v-model="settings.careerTestingChecked"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Test Interview for this vacancy</label>
      </div>
      
      <div class="job-card" v-if="settings.careerTestingChecked">
        <!-- <div class="form-group">
            <input v-model="settings.googleFormsForCareerTesting" placeholder="Add the Google forms url for the Test" type="text" class="form-control" name="settings_googleforms" id="settings_googleforms" />
        </div>
        <div class="form-group">
            <input v-model="settings.responseSpreadsheetForGoogleForms" placeholder="Add the Google sheet url for the response of the google forms above" type="text" class="form-control" name="settings_googlesheet" id="settings_googlesheet" />
        </div>
        <div class="form-group">
            <input type="checkbox" v-model="settings.setAutomaticScoring"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Set Automatic scoring of the response</label>
        </div> -->
        <div class="d-flex">
            <!-- <div class="col-xs-6 col-md-6 p-0 pl-sm-2">
                <label class="col-form-label">  Score for each question</label>
            <input v-model="settings.scorePerQuestion" placeholder="Score for each question" type="number" class="form-control" name="settings_scoreperquest" id="settings_scoreperquest" />
            </div> -->
            <div class="col-xs-6 col-md-6 p-0 pl-sm-2">
                <label class="col-form-label">  What is the average score an application must have</label>
            <input v-model="settings.passAverageScore" placeholder="What is the average score an application must have" type="number" class="form-control" name="settings_passscore" id="settings_passscore" />
            </div>
        </div>
        <p>Welcome message when application proceed to Career / Aptitude Test stage</p>
        <quill-editor
          v-model="settings.welcomeMessageToCareerTesting"
          ref="myQuillEditor"
          :options="editorOption"
        >
        </quill-editor>
      </div>
    </div>
    <div class="col-xs-12 col-md-12">
      <div class="job-card">
        <p>Welcome message when application proceed to medical stage</p>
        <quill-editor
          v-model="settings.medicalMessage"
          ref="myQuillEditor"
          :options="editorOption"
        >
        </quill-editor>
      </div>
    </div>
    <div class="col-xs-12 col-md-12 job-card">
      <div class="d-flex align-items-center">
        <label class="col-form-label">  Offer Information for this vacancy</label>
        <p>The checked information will be display at offer stage</p>
      </div>
      
      <div class="job-card">
        <div class="form-group" style="margin-bottom: 0">
            <input type="checkbox" v-model="settings.expectedResumptionDate"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Expected Resumption Date</label>
        </div>
        <div class="form-group" style="margin-bottom: 0">
            <input type="checkbox" v-model="settings.expectedSalary"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Expected Salary</label>
        </div>
        <div class="form-group" style="margin-bottom: 0">
            <input type="checkbox" v-model="settings.rank"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Rank</label>
        </div>
        <div class="form-group" style="margin-bottom: 0">
            <input type="checkbox" v-model="settings.probationPeriod"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Probation Period</label>
        </div>
        <div class="form-group">
            <input type="checkbox" v-model="settings.reportingTo"  /> &nbsp;&nbsp;&nbsp;<label class="col-form-label">  Reporting To</label>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "job-requisition",
  props: {
         settings: {}
      },
  data() {
    return {
          //requisition: this.requisition,
          //content: "<p>I am Example</p>",
          editorOption: {},
          durationList: [{value: 10, text: '10 minutes'},{value: 20, text: '20 minutes'},{value: 30, text: '30 minutes'},{value: 60, text: '1 hour'}],
          amList: [{value: 1, text: '1:00 AM'},{value: 2, text: '2:00 AM'},{value: 3, text: '3:00 AM'},{value: 4, text: '4:00 AM'},{value: 5, text: '5:00 AM'},{value: 6, text: '6:00 AM'},{value: 7, text: '7:00 AM'},{value: 8, text: '8:00 AM'},{value: 9, text: '9:00 AM'},{value: 10, text: '10:00 AM'},{value: 11, text: '11:00 AM'},{value: 12, text: '12:00 NOON'}],
          pmList: [{value: 13, text: '1:00 PM'},{value: 14, text: '2:00 PM'},{value: 15, text: '3:00 PM'},{value: 16, text: '4:00 PM'},{value: 17, text: '5:00 PM'},{value: 18, text: '6:00 PM'},{value: 19, text: '7:00 PM'},{value: 20, text: '8:00 PM'},{value: 21, text: '9:00 PM'},{value: 22, text: '10:00 PM'},{value: 23, text: '11:00 PM'}]
    }
  },
  mounted() {
    this.$emit('update:settings', this.settings);
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    onEditorChange({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    },
    onEditorChange1({ quill, html, text }) {
      // console.log("editor change!", quill, html, text);
      this.content = html;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/vacancies/vacancy-settings.vue